@if (show()) {
    <div class="alert alert-light mt-2 p-2 d-flex align-items-center {{containerClass()}}" role="alert">
        <i class="ti ti-alert-circle me-2"></i> {{ (shortMessage() ? 'messages.error.not_found_record_for_filter_short' : 'messages.error.not_found_record_for_filter') | translate }}
    </div>
}
